define('views/app/login/layout-login',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/login/login-form',
    // templates
    'text!templates/app/login/layout-login.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VLoginForm,
    // templates
    TLayoutLogin
) {

    var VLayoutLogin = Backbone.View.extend({
        template: TLayoutLogin,
        id: "login-layout",

        regions: {
            form: "#login-form",
        },

        initialize: function(options) {
            this.view = {
                form: new VLoginForm(),
            };
        },

        render: function() {
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones()
                .assign(this.view.form, this.zone.$form);

            return this;
        },

    });

    return VLayoutLogin;
});

